const NOTION_TOKEN = process.env.REACT_APP_NOTION_TOKEN;
const NOTION_DB_ID = process.env.REACT_APP_NOTION_DB_ID;
// Note: Notion APIは直接ブラウザから叩けないためVercel Edge Functionなどのプロキシ経由が必要
// 開発中はモックのみ
const PROXY_URL = process.env.REACT_APP_NOTION_PROXY_URL || '';

/**
 * 音読記録をNotionデータベースに保存
 * @param {object} record
 */
export async function saveToNotion(record) {
  if (!NOTION_TOKEN || !NOTION_DB_ID) {
    console.info('Notion設定なし。スキップします。');
    return;
  }

  const url = PROXY_URL
    ? `${PROXY_URL}/api/notion-save`
    : null;

  if (!url) {
    console.info('Notion プロキシURLが未設定です。');
    return;
  }

  const body = {
    parent: { database_id: NOTION_DB_ID },
    properties: {
      タイトル: { title: [{ text: { content: record.title ?? '音読' } }] },
      日付: { date: { start: record.date ?? new Date().toISOString() } },
      スコア: { number: record.avgScore ?? 0 },
      スター: { number: record.totalStars ?? 0 },
      モード: { select: { name: record.mode === 'honban' ? 'ほんばん' : 'れんしゅう' } },
    },
  };

  try {
    await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
  } catch (e) {
    console.error('Notion保存エラー:', e);
  }
}

/**
 * フィードバックをNotionデータベースに保存
 * @param {{ category: string, message: string }} feedback
 */
export async function sendFeedback({ category, message, senderName, senderGrade, isGuest }) {
  const res = await fetch('/api/notion-feedback', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ category, message, senderName, senderGrade, isGuest }),
  });

  if (!res.ok) {
    throw new Error(`Notionフィードバック送信エラー: ${res.status}`);
  }
}
